import React from 'react'
import Selector from './selector'
import createReactClass from 'create-react-class'


var SelectorContainer = createReactClass({

	render: function() {
		return (
			<Selector />
		);
	}
});

export default SelectorContainer;
